export default __webpack_public_path__ + "static/BelleTire-fist-bump-6ea179d43fcbd5fb7a24c4205ddf3d46.png";